import {
  FETCH_CANCELLATION_MODAL_SETTINGS,
} from 'actions/apiActionConstants'
import { reducerSwitch, createReducer } from 'lib/redux/reducerUtils'
import { API_CALL_REQUEST, API_CALL_SUCCESS } from 'actions/actionConstants'

export const initialCancellationModalSettingsState = {
  id: '',
  rules: [] as Array<App.CancellationModalRule>,
  createdAt: new Date(),
  updatedAt: new Date(),
}

const apiRequests = reducerSwitch<App.CancellationModalSettings>({
  [FETCH_CANCELLATION_MODAL_SETTINGS]: (state) => {
    return state
  },
})

const apiSuccesses = reducerSwitch<App.CancellationModalSettings>({
  [FETCH_CANCELLATION_MODAL_SETTINGS]: (state, action) => {
    return action.data
  },
})

const cancellationModalSettingsReducer = createReducer(
  initialCancellationModalSettingsState,
  {
    [API_CALL_REQUEST]: (state, action) => apiRequests(action.api)(state, action),
    [API_CALL_SUCCESS]: (state, action) =>
      apiSuccesses(action.api)(state, action),
  },
)

export default cancellationModalSettingsReducer
